import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ResourceTableBody from '@presentational/ResourceTableBody';
import ResourceTableHeaders from '@presentational/ResourceTableHeaders';
import { ta } from 'utils';

import ItemLink from '@presentational/ItemLink';

const propTypes = {
  // reportData: reportItemsShape,
  transferURLBase: PropTypes.string.isRequired,
  isSeller: PropTypes.bool.isRequired,
  skuTooltip: PropTypes.string.isRequired,
}

const defaultProps = {

}
// I18n.l("time.formats.long", )
const SaleReportTransfersBrief = (props) => {
  
  let columnsDataDraft = null;
  
  if(props.isSeller) {
    columnsDataDraft = [
      { size: 2, header: I18n.t("activerecord.models.transfer.one"), tooltip: props.skuTooltip,
        accessor: (data) => (<ItemLink url={ props.transferURLBase.replace("URL_ID", data.transfer_id) } content={ data.transfer_name } /> ),
      },
      { size: 3, header: I18n.t("sale_report.transfer_created_at"), accessor: (data) => I18n.l("time.formats.long", data.transfer_created_at) },
      { size: 3, header: ta("transfer.invoice_number"), accessor: "transfer_invoice_number" },
      { size: 2, header: I18n.t("sale_report.transfer_invoice_amount"), accessor: "transfer_invoice_amount_money" },
      { size: 2, header: I18n.t("sale_report.amount_paid"), accessor: "amount_paid_money" },
    ];
  } else {
    columnsDataDraft = [
      { size: 2, header: I18n.t("sale_report.transfer_vendor"), accessor: "transfer_vendor" },
      { size: 2, header: I18n.t("activerecord.models.transfer.one"), tooltip: props.skuTooltip,
        accessor: (data) => (<ItemLink url={ props.transferURLBase.replace("URL_ID", data.transfer_id) } content={ data.transfer_name } /> ),
      },
      { size: 2, header: I18n.t("sale_report.transfer_created_at"), accessor: (data) => I18n.l("time.formats.long", data.transfer_created_at) },
      { size: 2, header: ta("transfer.invoice_number"), accessor: "transfer_invoice_number" },
      { size: 2, header: I18n.t("sale_report.transfer_invoice_amount"), accessor: "transfer_invoice_amount_money" },
      { size: 2, header: I18n.t("sale_report.amount_paid"), accessor: "amount_paid_money" },
    ];
  }

  const columnsData = columnsDataDraft;
  const colSizeForTotalValue = columnsData.at(-1).size;
  const colSizeForTotalText = 12 - colSizeForTotalValue;
  
  return (
    <div>
      <ResourceTableHeaders
        columnsInfo={columnsData}
      />
      { props.reportData.map( ({full_amount_money, data, full_amount}, index)  =>
        <div key={index}>
          <ResourceTableBody
            columnsInfo={columnsData}
            items={ data }
            itemURL={null}
          />
          { full_amount > 0 &&
            <div className="container-fluid pv15 bg-gray mb40">
              <div className="row">

                <div className={`col-md-${colSizeForTotalText}`}>
                  Total
                </div>
                <div className={`col-md-${colSizeForTotalValue}`}>
                  { full_amount_money }
                </div>

              </div>
            </div>
          }
        </div>
      )}
    </div>
  )
};

SaleReportTransfersBrief.propTypes = propTypes;
SaleReportTransfersBrief.defaultProps = defaultProps;

export default SaleReportTransfersBrief;